import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {CoreComponent} from '@core/core.component';
import {AuthGuard} from '@modules/shared/guard';
import {RoleGuard} from '@modules/shared/guard/role.guard';

const routes: Routes = [
  {
    path: '',
    component: CoreComponent,
    children: [
      {
        path: '',
        redirectTo: 'explorar',
        canActivate: [AuthGuard],
        data: {title: ''}
      },
      {
        path: 'explorar',
        loadChildren: () => import('@modules/explore/explore.module').then(m => m.ExploreModule),
        canActivate: [AuthGuard],
        data: {title: 'Explorar'}
      },
      {
        path: 'archivo',
        loadChildren: () => import('@modules/archive/archive.module').then(m => m.ArchiveModule),
        canActivate: [AuthGuard],
        data: {title: 'Archivo'}
      },
      {
        path: 'mis_aportes',
        loadChildren: () => import('@modules/my-contributions/my-contributions.module').then(m => m.MyContributionsModule),
        canActivate: [AuthGuard],
        data: {title: 'Mis Aportes'}
      },
      {
        path: 'user_profile',
        loadChildren: () => import('@modules/user-profile/user-profile.module').then(m => m.UserProfileModule),
        canActivate: [AuthGuard],
        data: {title: 'Perfil de usuari@'}
      },
      {
        path: 'tablon',
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/board/board.module').then(m => m.BoardModule),
        data: {title: 'Tablón'}
      },
      {
        path: 'enlaces',
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/relevant-links/relevant-links.module').then(m => m.RelevantLinksModule),
        data: {title: 'Enlaces'}
      },
      {
        path: 'recursos',
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/resources/resources.module').then(m => m.ResourcesModule),
        data: {title: 'Recursos'}
      },
      {
        path: 'anuncios',
        canActivate: [AuthGuard],
        loadChildren: () => import('@modules/announcements/announcements.module').then(m => m.AnnouncementsModule),
        data: {title: 'Anuncios'}
      },
      {
        path: 'moderar',
        loadChildren: () => import('@modules/moderate/moderate.module').then(m => m.ModerateModule),
        canActivate: [AuthGuard, RoleGuard],
        data: {title: 'Moderar', name: 'moderate'}
      },
      {
        path: 'admin',
        loadChildren: () => import('@modules/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard, RoleGuard],
        data: {title: 'Administración', name: 'admin'}
      },
      {
        path: 'mensajes',
        loadChildren: () => import('@modules/messages/messages.module').then(m => m.MessagesModule),
        canActivate: [AuthGuard],
        data: {title: 'Mensajes', name: 'mensajes'}
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CoreRoutingModule {
}
